import { Button, Result } from "antd";
import ComponentePermissao, { IComponentePermissaoProps } from "./ComponentePermissao";
import { useNavigate } from "react-router-dom";
export default function TelaPermissao ({
    renderNaoPermitido,
    ...rest
}:IComponentePermissaoProps) {
    const navigate = useNavigate();
    
    renderNaoPermitido = renderNaoPermitido ?? <Result
        status="403"
        title="Não autorizado"
        subTitle="Desculpe, você não está autorizado a acessar esta página."
        extra={<Button type="primary" onClick={() => navigate(-1)}>Voltar</Button>}
    />;

    return <ComponentePermissao 
        {...rest}
        renderNaoPermitido={renderNaoPermitido}
    />
}